"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BATCH_MILLISECONDS = 40;
exports.BATCH_NOTIFICATIONS = 100;
exports.CONTENT_BACKGROUND_CONNECT = "content-background-connect";
exports.CONTENT_MESSAGE = "content-message";
exports.EXTENSION_KEY = "__RX_SPY_EXTENSION__";
exports.PANEL_BACKGROUND_CONNECT = "panel-background-connect";
exports.PANEL_BACKGROUND_INIT = "panel-background-init";
exports.PANEL_MESSAGE = "panel-message";
exports.MESSAGE_BATCH = "batch";
exports.MESSAGE_BROADCAST = "broadcast";
exports.MESSAGE_CONNECT = "connect";
exports.MESSAGE_DISCONNECT = "disconnect";
exports.MESSAGE_REQUEST = "request";
exports.MESSAGE_RESPONSE = "response";
